"use strict";

import Parallax from "../global/parallax";
import SmoothScroll from "smooth-scroll";
import overunder from "overunder";
import styleSelect from "styleselect";
import { lazy } from "lazy-class";

let SoloJazz = {
  // cache dom elements
  dom: {
    hero: document.querySelector('.js-hero'),
    header: document.querySelector('.header'),
    siteParalless: document.querySelector('.js-slow-jazz')
  },
  init() {

    this.smoothScrolling();
    this.handleScrolling();
    this.handleHeader(this.dom.hero);
    styleSelect('select')

  },


  handleHeader(hero) {
    let backgrounds = hero.querySelectorAll('.home--hero-backgrounds div'),
      headlines = hero.querySelector('.js-headlines'),
      down = hero.querySelector('.js-down'),
      header = this.dom.header;

    lazy(headlines, 'loaded', 1000);
    lazy(backgrounds, 'loaded', 1200);
    lazy(down, 'loaded', 1300);
    lazy(backgrounds, 'size', 1350);
    lazy(header, 'loaded', 1400);
  },

  smoothScrolling() {
    let header = this.dom.header;
    SmoothScroll.init({
      selector: '[data-scroll]', // Selector for links (must be a valid CSS selector)
      selectorHeader: '[data-scroll-header]', // Selector for fixed headers (must be a valid CSS selector)
      speed: 500, // Integer. How fast to complete the scroll in milliseconds
      easing: 'easeInOutCubic', // Easing pattern to use
      updateURL: true, // Boolean. Whether or not to update the URL with the anchor hash on scroll
      offset: 40, // Integer. How far to offset the scrolling anchor location in pixels
      callback: function ( toggle, anchor ) {
        header.classList.remove('open');
        setTimeout(() => {
          header.classList.remove('opening');
        }, 250);
      } // Function to run after scrolling
    });
  },

  handleScrolling() {

    let productOne = document.querySelector('.js-product-one'),
      productTwo = document.querySelector('.js-product-two'),
      founder = document.querySelector('.js-founder');
    let handleScrolling = () => {
      Parallax.init(productOne, -8, 300);
      Parallax.init(productTwo, -8, 300);
      Parallax.init(founder, -8, 100);
    }

    window.addEventListener('scroll', handleScrolling);
  }
}

export default SoloJazz;



/** WEBPACK FOOTER **
 ** ./es6/partials/solojazz.js
 **/